import React from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
export function HowItWorks() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  const steps = [{
    number: '1',
    title: 'Your consultation',
    description: 'We assess your skin and customize depth and intensity.'
  }, {
    number: '2',
    title: 'The session (60 min)',
    description: "RF energy triggers your skin's natural healing cascade."
  }, {
    number: '3',
    title: 'Your transformation (4–12 weeks)',
    description: 'Collagen builds. Skin tightens. Results emerge.'
  }];
  return <section className="py-24 bg-warm-bg relative" data-id="element-170">
      <div className="container mx-auto px-4 md:px-8 max-w-5xl" data-id="element-171">
        <div ref={ref} className={`text-center mb-20 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-172">
          <h2 className="font-serif text-3xl md:text-4xl text-text-dark" data-id="element-173">
            How It Works
          </h2>
        </div>

        <div className="relative" data-id="element-174">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-px bg-divider z-0" data-id="element-175"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-176">
            {steps.map((step, index) => <div key={index} className={`flex flex-col items-center text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
            transitionDelay: `${index * 200 + 200}ms`
          }} data-id="element-177">
                <div className="w-14 h-14 rounded-full bg-white border border-gold flex items-center justify-center text-gold font-serif text-xl mb-8 shadow-sm relative" data-id="element-178">
                  {/* Connecting Line (Mobile) */}
                  {index !== steps.length - 1 && <div className="md:hidden absolute top-14 bottom-[-3rem] w-px bg-divider" data-id="element-179"></div>}
                  {step.number}
                </div>
                <h3 className="font-serif text-xl text-text-dark mb-3" data-id="element-180">
                  {step.title}
                </h3>
                <p className="text-text-dark/70 text-sm md:text-base px-4" data-id="element-181">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}